import pack from '../package.json';

export const { version, name } = pack;
export const supportedBrowsers = [
  {
    name: 'Chrome',
    lowestVersion: 52,
    excludedVersions: [],
    lowestRenderVersion: null,
  },
  {
    name: 'Firefox',
    lowestVersion: 63,
    excludedVersions: [],
    lowestRenderVersion: null,
  },
  {
    name: 'Chromium',
    lowestVersion: 100,
    excludedVersions: [],
    lowestRenderVersion: null,
  },
];
export const portalURL = '*/portal/';
export const apiURL = '*/ns-api/';
export const nsSocketURLs = ['*:8001'];
export const uaSocketURLs = ['*:9002'];
export const devicePostFix = 'wp';
